import { render, staticRenderFns } from "./veStuAssocActivity.vue?vue&type=template&id=4d5ac2d8&scoped=true"
import script from "./veStuAssocActivity.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ac2d8",
  null
  
)

export default component.exports